/**
 * Created by spepa on 21.05.2024
 */

const YoutubeLocalStorage = function () {
    this.data = {};
    this.flush = connector.utils.accumulate(500, this._flush);
};

YoutubeLocalStorage.prototype.initialize = function (callback) {
    ytgame.game.loadData().then((data) => {
        if (data) {
            this.data = JSON.parse(data);
        }
        callback();
    }).catch((e) => {
        connector.platform.getPlugin().trigger("stream:error", e);
        callback();
    });
};

YoutubeLocalStorage.prototype.getItem = function (key) {
    return this.data[key];
};

YoutubeLocalStorage.prototype.setItem = function (key, value) {
    this.data[key] = value;
    this.flush();
};

YoutubeLocalStorage.prototype.removeItem = function (key) {
    delete this.data[key];
    this.flush();
};

YoutubeLocalStorage.prototype.clearData = function (prefix) {
    for (const key in this.data) {
        if (key.indexOf(prefix) === 0) {
            delete this.data[key];
            console.log("[connector] clearing local storage key", key);
        }
    }
    this.flush();
};

YoutubeLocalStorage.prototype.getData = function (prefix) {
    const data = {};
    for (const key in this.data) {
        if (key.indexOf(prefix) === 0) {
            data[key] = this.data[key];
        }
    }
    return data;
};

YoutubeLocalStorage.prototype._flush = function () {
    ytgame.game.saveData(JSON.stringify(this.data)).catch((e) => {
        connector.platform.getPlugin().trigger("stream:error", e);
    });
};